import { ReactNode, useEffect, useRef, useState } from "react";
import axios from "axios";
import Forward from "./Forward";

interface Props {
  children: ReactNode;
}

export default function ErrorHandler({ children }: Props) {
  const [hasError, setHasError] = useState(false);
  const [errorCode, setErrorCode] = useState(0);
  const skipErrorHandlingRef = useRef(false);

  useEffect(() => {
    const requestInterceptor = axios.interceptors.request.use((req) => {
      setHasError(false);
      skipErrorHandlingRef.current = req.data?.skipErrorHandling ?? false;
      return req;
    });

    const responseInterceptor = axios.interceptors.response.use(
      (res) => res,
      (error) => {
        if (skipErrorHandlingRef.current) {
          setHasError(false);
          setErrorCode(0);
          skipErrorHandlingRef.current = false;
        } else {
          setHasError(true);
          setErrorCode(error.response.status);
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.request.eject(requestInterceptor);
      axios.interceptors.response.eject(responseInterceptor);
    };
  }, []);

  if (hasError) {
    if (errorCode === 404) {
      return <Forward path="/notFound" />;
    }
    if (errorCode === 500) {
      return (
        <div>
          <h1>Sorry...internal error.</h1>
          <div>Please try again later.</div>
        </div>
      );
    }
  }

  return <>{children}</>;
}
